module.exports = __webpack_public_path__ + "static/media/progate.1cbdf646.png";